const ResetLocation = () => window.scrollTo(0, 0);

export default ResetLocation;